import React from "react";
import { useI18n } from "../../i18n";
import { formatAmount } from "../utils/money";

/**
 * The phone register's anchor: a fixed bar that shows what is in the ticket
 * and takes the cashier straight to payment in one tap.
 */
const CartBar = ({ totals, currency, onReview, onCharge }) => {
  const { t } = useI18n();
  const isEmpty = totals.itemCount === 0;

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-slate-900/95 backdrop-blur border-t border-slate-800 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-stretch gap-2 p-2.5">
        <button
          type="button"
          onClick={onReview}
          disabled={isEmpty}
          className="flex-1 min-w-0 flex flex-col justify-center px-3 py-2 rounded-xl bg-slate-800 border border-slate-700 text-start disabled:opacity-50 active:scale-[0.98] transition-all"
        >
          <span className="text-sm font-bold text-white truncate">
            {isEmpty
              ? t("pos.cart.noItems")
              : `${t("common.items", { count: totals.itemCount })} · ${formatAmount(
                  totals.subtotal,
                )} ${currency}`}
          </span>
          <span className="text-[11px] text-slate-400">
            {isEmpty ? t("pos.cart.tapProduct") : t("pos.cart.review")}
          </span>
        </button>

        <button
          type="button"
          onClick={onCharge}
          disabled={isEmpty}
          className="shrink-0 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-800 disabled:text-slate-500 text-white font-extrabold flex flex-col items-center justify-center shadow-lg shadow-emerald-600/20 active:scale-95 transition-all"
        >
          <span className="text-lg tabular-nums leading-tight">
            {formatAmount(totals.total)}
          </span>
          <span className="text-[10px] uppercase tracking-widest leading-tight">
            {t("pos.cart.charge")}
          </span>
        </button>
      </div>
    </div>
  );
};

export default CartBar;
